// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonItem_body__1vlM3"};